import React from "react";

export const useScreenWidth = () => {
  const getWidth = () =>
    typeof window !== "undefined" ? window.innerWidth : 0;

  const [width, setWidth] = React.useState(getWidth);

  React.useEffect(() => {
    let rafId: number | null = null;

    const handleResize = () => {
      if (rafId) return;

      rafId = window.requestAnimationFrame(() => {
        const newWidth = window.innerWidth;

        // ✅ avoid unnecessary re-render
        setWidth((prev) => (prev !== newWidth ? newWidth : prev));

        rafId = null;
      });
    };

    window.addEventListener("resize", handleResize, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return width;
};
